'use client';

export { default } from './useScrollTrigger';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/useScrollTrigger/index.js
// module id = 907
// module chunks = 22